/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as yup from "yup";

const r = new RegExp(/^[a-zA-Z0-9-_!@#$%^&*(),.?":{}|<>]+$/);

export const resourceGroupSchema = yup.object().shape({
  value: yup.string().required().matches(r, "Only single word is allowed"),
});
